import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { IHamburgerMenuRootProps } from '../HamburgerMenuRoot.props';
import type { IHamburgerMenuRootDefinition } from '../documentManagement/HamburgerMenuRoot.definition';
import type { IHamburgerMenuRootCarmiProps } from './HamburgerMenuRoot.mapper';
import {
  props as viewerPropsMapper,
  stateRefs,
} from './HamburgerMenuRoot.mapper';

const props = composeMapper<
  IHamburgerMenuRootProps,
  IHamburgerMenuRootDefinition,
  IHamburgerMenuRootCarmiProps
>()(
  viewerPropsMapper,
  {
    add: ['compPreviewState', 'componentViewMode'],
  },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);
    const { compPreviewState, componentViewMode } = dependencies;

    return {
      ...viewerProps,
      compPreviewState:
        componentViewMode === 'editor' ? compPreviewState : null,
      shouldFocus: componentViewMode === 'preview',
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
  stateRefs,
});
